export default () => (
  /**
   * Icone de uma linha que liga dois pontos.
   * Responsavel por fazer linhas no mapa.
   * Encontrada na ferramenta de inserir geometrias.
   */
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="2.49434" cy="2.0002" r="1.8" fill="#BEC7DC" />
    <circle cx="11.4943" cy="15.0002" r="1.8" fill="#BEC7DC" />
    <path
      d="M2.19434 1.7002L10.6943 13.7002"
      stroke="#BEC7DC"
      strokeWidth="1.5"
    />
  </svg>
);
